/* tslint:disable */
/* eslint-disable */
/**
 * CallNowButton API
 * API for CallNowButton. Includes auth, domains, buttons/actions/conditions, but also chat and admin features.
 *
 * The version of the OpenAPI document: 0.0.221-development
 * Contact: support@nowbuttons.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AvailabilityWindow
 */
export interface AvailabilityWindow {
    /**
     * 
     * @type {string}
     * @memberof AvailabilityWindow
     */
    dayOfWeek: AvailabilityWindowDayOfWeekEnum;
    /**
     * 
     * @type {string}
     * @memberof AvailabilityWindow
     */
    startTime: string;
    /**
     * 
     * @type {string}
     * @memberof AvailabilityWindow
     */
    endTime: string;
}


/**
 * @export
 */
export const AvailabilityWindowDayOfWeekEnum = {
    Monday: 'MONDAY',
    Tuesday: 'TUESDAY',
    Wednesday: 'WEDNESDAY',
    Thursday: 'THURSDAY',
    Friday: 'FRIDAY',
    Saturday: 'SATURDAY',
    Sunday: 'SUNDAY'
} as const;
export type AvailabilityWindowDayOfWeekEnum = typeof AvailabilityWindowDayOfWeekEnum[keyof typeof AvailabilityWindowDayOfWeekEnum];


/**
 * Check if a given object implements the AvailabilityWindow interface.
 */
export function instanceOfAvailabilityWindow(value: object): value is AvailabilityWindow {
    if (!('dayOfWeek' in value) || value['dayOfWeek'] === undefined) return false;
    if (!('startTime' in value) || value['startTime'] === undefined) return false;
    if (!('endTime' in value) || value['endTime'] === undefined) return false;
    return true;
}

export function AvailabilityWindowFromJSON(json: any): AvailabilityWindow {
    return AvailabilityWindowFromJSONTyped(json, false);
}

export function AvailabilityWindowFromJSONTyped(json: any, ignoreDiscriminator: boolean): AvailabilityWindow {
    if (json == null) {
        return json;
    }
    return {
        
        'dayOfWeek': json['dayOfWeek'],
        'startTime': json['startTime'],
        'endTime': json['endTime'],
    };
}

export function AvailabilityWindowToJSON(json: any): AvailabilityWindow {
    return AvailabilityWindowToJSONTyped(json, false);
}

export function AvailabilityWindowToJSONTyped(value?: AvailabilityWindow | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'dayOfWeek': value['dayOfWeek'],
        'startTime': value['startTime'],
        'endTime': value['endTime'],
    };
}

